import * as React from 'react';
import styled from '@emotion/styled';
import { Button, Classes } from '@blueprintjs/core';
import { MAP } from '@blueprintjs/icons/lib/esm/generated/iconNames';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';

interface DutiesListActionsProps extends WithTranslateProps {
  onShowOnMap: () => void;
}

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  & .${Classes.BUTTON} {
    margin-right: 50px;
  }
`;

class DutiesListActions extends React.PureComponent<DutiesListActionsProps> {
  render() {
    return (
      <ButtonContainer>
        <Button icon={MAP} onClick={this.props.onShowOnMap} text={this.props.translate(TLCode.DutiesShowWideMap)} />
      </ButtonContainer>
    );
  }
}

export default withTranslate(DutiesListActions);
